import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function updateCords(state = initialState.floatingPanelCords, action) {
  switch (action.type) {
    case types.SET_CORDS: {
      return Object.assign({}, state, {
        display: action.display,
        pageX: action.pageX,
        pageY: action.pageY,
      });
    }
    case types.RESET_CORDS: {
      return initialState.floatingPanelCords;
    }
    default:
      return state;
  }
}
